module.exports = __webpack_public_path__ + "static/media/banner-brios-feria-empresarial-la-montana-12.b44d8b21.webp";